import React from 'react';
import styled from 'styled-components';

import { Checkmark } from './checkmark';
import { primaryFont, secondaryFont } from 'react-components/dist/values/fonts/fonts';

const MainTitle = styled.div`
  color: ${props => props.color};
  font: ${primaryFont.xlarge};
  font-size: 3em;
`;

export const Title = ({ color, text }) => <MainTitle color={color}>{text}</MainTitle>;

const SecondaryTitle = styled.div`
  color: ${props => props.color};
  font: ${primaryFont.large};
  font-size: 2em;
  line-height: 1em;
`;

export const Subtitle = ({ color, text, style }) => {
  return (
    <SecondaryTitle
style={style}
color={color}>
      {text}
    </SecondaryTitle>
  );
};

const TextBlock = styled.div`
  color: ${props => props.color};
  font: ${secondaryFont.large};
  font-size: ${props => (props.large ? '1.6em' : '1em')};
  line-height: ${props => (props.large ? '1.6em' : '1em')};
`;

export const Text = ({ color, text, large }) => (
  <TextBlock
color={color}
large={large}
dangerouslySetInnerHTML={{ __html: text }} />
);

const TextStrong = styled.div`
  font: ${primaryFont.medium};
`;

export const Strong = ({ text }) => <TextStrong>{text}</TextStrong>;

const ListContainer = styled.div`
  color: ${props => props.color};
  font: ${secondaryFont.large};
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
`;

const ListItem = styled.div`
  text-align: left;
  display: flex;
  & > svg {
    min-width: 24px;
    height: 24px;
    margin-top: -8px;
    margin-right: 8px;
  }
`;

export const List = ({ items, color }) => (
  <ListContainer color={color}>
    {items.map((x, i) => (
      <ListItem key={i}>
        <Checkmark />
        <div>{x}</div>
      </ListItem>
    ))}
  </ListContainer>
);
